import { FileDown, Wrench } from "lucide-react";
import { GOOGLE_REVIEW_URL } from "@/data/site";

const CHECKLIST_LABELS = {
  filter_change: "Filter change", coil_inspection: "Coil inspection", drain_line: "Drain line service",
  belt_inspection: "Belt inspection", refrigerant_check: "Refrigerant level check", electrical_check: "Electrical check",
};
const VALUE_LABELS = { ok: "OK", attention: "Needs attention", na: "N/A" };
const VALUE_TONES = { ok: "bg-green-100 text-green-800", attention: "bg-amber-100 text-amber-800", na: "bg-zinc-100 text-zinc-600" };

const fileUrl = (reportId, fileId) => `${process.env.REACT_APP_BACKEND_URL}/api/visit-files/${reportId}/${fileId}`;

export const VisitReportItem = ({ visit }) => (
  <li data-testid={`visit-report-${visit.id}`} className="py-4 first:pt-0 last:pb-0">
    <div className="flex flex-wrap items-center justify-between gap-2">
      <p className="font-medium text-brand-ink flex items-center gap-2">
        <Wrench className="w-4 h-4 text-brand" /> Maintenance Visit{visit.location ? ` — ${visit.location.label}` : ""}
      </p>
      <span className="text-xs font-bold px-2.5 py-1 rounded-sm uppercase tracking-wide bg-brand-subtle text-brand">Completed</span>
    </div>
    <p className="text-xs text-zinc-500 mt-1">
      {visit.date}{visit.location ? ` · ${visit.location.address}` : ""} · Technician: {visit.technician_name}
    </p>
    <div className="flex flex-wrap gap-1.5 mt-2">
      {Object.entries(visit.checklist).map(([k, v]) => (
        <span key={k} data-testid={`visit-checklist-${visit.id}-${k}`}
          className={`text-xs font-medium px-2 py-1 rounded-sm ${VALUE_TONES[v] || VALUE_TONES.na}`}>
          {CHECKLIST_LABELS[k] || k}: {VALUE_LABELS[v] || v}
        </span>
      ))}
    </div>
    {visit.notes && <p className="text-sm text-zinc-600 mt-2"><span className="font-bold text-brand-ink">Notes:</span> {visit.notes}</p>}
    {visit.recommended_repairs && (
      <p className="text-sm text-zinc-600 mt-1"><span className="font-bold text-brand-ink">Recommended repairs:</span> {visit.recommended_repairs}</p>
    )}
    {visit.photos.length > 0 && (
      <div className="flex flex-wrap gap-2 mt-2">
        {visit.photos.map((p) => (
          <a key={p.file_id} href={fileUrl(visit.id, p.file_id)} target="_blank" rel="noopener noreferrer">
            <img src={fileUrl(visit.id, p.file_id)} alt="Visit" className="w-20 h-20 object-cover rounded-sm border border-zinc-200" />
          </a>
        ))}
      </div>
    )}
    <div className="flex flex-wrap gap-2 mt-3">
      {visit.invoice && (
        <a href={fileUrl(visit.id, visit.invoice.file_id)} target="_blank" rel="noopener noreferrer"
          data-testid={`visit-invoice-btn-${visit.id}`}
          className="inline-flex items-center gap-1.5 bg-brand hover:bg-brand-dark text-white font-bold px-4 py-2 rounded-sm text-xs transition-colors duration-200">
          <FileDown className="w-3.5 h-3.5" /> Download Invoice
        </a>
      )}
      <a href={GOOGLE_REVIEW_URL} target="_blank" rel="noopener noreferrer" data-testid={`visit-review-btn-${visit.id}`}
        className="inline-flex items-center gap-1.5 border-2 border-brand text-brand hover:bg-brand hover:text-white font-bold px-4 py-2 rounded-sm text-xs transition-colors duration-200">
        Leave Us a Google Review
      </a>
    </div>
  </li>
);
